import React, {useState} from 'react';
import {
    Button,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    InputLabel,
    Modal,
    ModalActions,
    ModalContent,
    ModalTitle,
    Radio,
    RadioGroup
} from "@deere/fuel-react";
import {Controller, useForm} from "react-hook-form";
import {UserSearch} from "../UserSearch";

export const FeedbackDeclineModal = ({onSave}) => {
    const {handleSubmit, register, control, watch, setValue, formState: {errors}} = useForm({ defaultValues: { replacementsName: "" }});
    const [open, setOpen] = useState(false);

    const declineReasons = ["I am assigned to this supplier, but have not had interaction in this rating period.", "I do not work with this supplier; do not reassign.", "I do not work with this supplier; reassign to:"];

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = (data) => {
        setOpen(false);
        onSave(data)
    }

    return (
        <div>
            <Button variant="text" size="large" style={{marginRight: "1rem"}} onClick={handleClickOpen}>
                Decline Request
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-Modal-title"
                aria-describedby="alert-Modal-description"
                maxWidth="sm"
                fullWidth={true}
            >
                <ModalTitle onClose={handleClose} id="alert-Modal-title">
                    Decline Request
                </ModalTitle>
                <ModalContent dividers>
                    <Grid container alignItems="center" spacing={4}>
                        <Grid item xs={12}>
                            <FormControl required fullWidth error={!!errors.comments || !!errors.stakeholderReplacement}>
                                <InputLabel>Decline Reason</InputLabel>
                                <Controller
                                    rules={{required: true}}
                                    name="comments"
                                    control={control}
                                    render={({ onChange, field }) => (
                                        <RadioGroup
                                            {...field}
                                            onChange={(e) => {
                                                onChange(e.target.value);
                                            }}>
                                            {declineReasons.map(reason => (
                                                <FormControlLabel key={reason} control={<Radio />} label={reason} value={reason} />
                                            ))}
                                        </RadioGroup>
                                    )}
                                />
                                <FormHelperText>{errors.comments && "Please enter reason to decline"}</FormHelperText>
                            </FormControl>
                            {watch("comments") === declineReasons[2] && (
                                <>
                                    <FormControl required fullWidth error={!!errors.stakeholderReplacement}>
                                        <InputLabel>Replacement</InputLabel>
                                        <Controller
                                            rules={{required: true}}
                                            name="stakeholderReplacement"
                                            control={control}
                                            render={({ onChange, field }) => (
                                                <UserSearch
                                                    {...field}
                                                    onOptionsChange={(e) => {
                                                        onChange(e.racfID);
                                                        setValue("replacementsName", e.displayName + " (" + e.racfID + ")");
                                                    }}
                                                />
                                            )}
                                        />
                                        <FormHelperText>{errors.stakeholderReplacement && "Please enter stakeholder for replacement"}</FormHelperText>
                                    </FormControl>
                                    <input {...register("replacementsName")} type="hidden"/>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </ModalContent>
                <ModalActions>
                    <Button onClick={handleClose} variant="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit(data => handleSave(data))} variant="primary">
                        Decline Request
                    </Button>
                </ModalActions>
            </Modal>
        </div>

    );
};


